import { CodeDocsHeader } from '@af/design-system-docs-ui';
import ERTInline from "!!extract-react-types-loader!../../../../../../packages/design-system/primitives/extract-react-types/inline-props";
import * as React from 'react';
export default {
  CodeDocsHeader,
  ERTInline,
  React
};